(function( $ ){
    $( '#side-bar-toggle' ).on( 'click', function(){
        $( '#secure-wrapper' ).toggleClass( 'side-bar-toggled' );
    } );
})( jQuery );
